import { render, staticRenderFns } from "./Manter.vue?vue&type=template&id=c66185d2"
import script from "./Manter.vue?vue&type=script&lang=ts"
export * from "./Manter.vue?vue&type=script&lang=ts"
import style0 from "./Manter.vue?vue&type=style&index=0&id=c66185d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports